import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import type { ElementType } from 'react';
import { ChevronRight } from '@kula-ai/icons-core';

interface NavButtonProps {
  icon?: ElementType;
  title?: string;
  count?: number;
  arrow?: boolean;
  active?: boolean;
  isCollapsed?: boolean;
  // Draws the in-place notch (white row + bottom concave curve) when open.
  notched?: boolean;
  // Renders as a side-nav row: `.nav` class + route-row spacing.
  navRow?: boolean;
}

export const NavButton = ({
  icon,
  title,
  count = 0,
  arrow = false,
  active = false,
  isCollapsed,
  notched = false,
  navRow = false,
}: NavButtonProps) => {
  return (
    <Tooltip
      isDisabled={!isCollapsed}
      label={title}
      arrowSize={8}
      hasArrow
      placement="right"
      borderRadius="4px"
      variant="default"
    >
      <Flex
        className={
          [navRow && 'nav', notched && 'nav-inplace-notch']
            .filter(Boolean)
            .join(' ') || undefined
        }
        {...(notched ? { 'data-notch-bottom': '' } : {})}
        alignItems="center"
        cursor="pointer"
        p={navRow ? '12px 10px 12px 12px' : '8px 6px 8px 12px'}
        borderRadius="6px"
        mb={navRow ? '0' : '2px'}
        minH="42px"
        _hover={{ bg: 'white' }}
        bg={active ? 'white' : undefined}
      >
        <Icon
          className="primary-900"
          as={icon}
          width="18px"
          height="18px"
          strokeWidth={1.2}
          mr="10px"
        />
        {!isCollapsed && (
          <Text
            flex="1"
            size="sm-regular"
            color="primary-900"
            fontSize="14px"
            fontWeight={active ? 650 : 450}
          >
            {title}
          </Text>
        )}
        {isCollapsed && count > 0 && (
          <Box
            bg="#444CE7"
            padding="3px"
            borderRadius="100%"
            position="relative"
            left="-8px"
            top="-3px"
          ></Box>
        )}
        {!isCollapsed && count > 0 && (
          <Flex
            bg="primary-100"
            color="primary-700"
            px="8px"
            py="4px"
            mr="5px"
            h="20px"
            minW="20px"
            borderRadius="full"
            fontSize="xs"
            alignItems="center"
            justifyContent="center"
            fontWeight="semiBold"
          >
            {count}
          </Flex>
        )}
        {arrow && <Icon ml="14px" as={ChevronRight} />}
      </Flex>
    </Tooltip>
  );
};
